import React from "react";
const RMMSContext = new React.createContext();
export default RMMSContext;